import styled from 'styled-components';
import { Upload } from 'antd';

const { Dragger } = Upload;
export const StyledUploadFile = styled(Dragger)`
  border-radius: 8px;

  .ant-upload-drag {
    border: 2px dashed;
    border-color: ${({ theme }) => theme.palette.secondary.main};
    background-color: #f3fffc;
    padding: 24px;

    &:hover {
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
    }

    p.ant-upload-text {
      font-size: 14px;
      line-height: 20px;
      color: rgba(62, 69, 77, 1);
      margin-top: 12px;
      span {
        font-weight: 500;
        color: ${({ theme }) => theme.palette.text.secondary} !important;
      }
    }

    p.ant-upload-hint {
      font-size: 12px;
      margin-top: 4px;
    }
  }

  .ant-upload-drag-icon {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(234, 236, 239, 1);
    border-radius: 8px;
    margin: 0 auto 16px auto;
  }

  /* Mobile responsive styles */
  @media (max-width: 768px) {
    .ant-upload-drag {
      padding: 16px;
    }

    .ant-upload-drag-icon {
      width: 36px;
      height: 36px;
      margin: 0 auto 12px auto;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    p.ant-upload-text {
      font-size: 13px !important;
      line-height: 18px !important;
      margin-top: 8px !important;
    }

    p.ant-upload-hint {
      font-size: 11px !important;
      margin-top: 4px !important;
    }
  }

  @media (max-width: 480px) {
    .ant-upload-drag {
      padding: 12px;
    }

    .ant-upload-drag-icon {
      width: 32px;
      height: 32px;
      margin: 0 auto 8px auto;

      svg {
        width: 18px;
        height: 18px;
      }
    }

    p.ant-upload-text {
      font-size: 12px !important;
      line-height: 16px !important;
      margin-top: 6px !important;
    }

    p.ant-upload-hint {
      font-size: 10px !important;
    }
  }
`;

export const StyledFilePreviewContainer = styled.div`
  font-family: ${({ theme }) => theme.font.family};
  border-radius: 8px;
  padding: 9px;
  border: 1px solid rgba(213, 217, 222, 1);
  position: relative;

  .file-preview {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 20px;
    color: rgba(62, 69, 77, 1);
    padding-right: 32px;

    > img {
      width: 30px;
      height: 30px;
      object-fit: contain;
      flex-shrink: 0;
    }

    svg {
      font-size: 20px;
      color: #ff4d4f;
      flex-shrink: 0;
    }

    .file-preview-meta {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      min-width: 0;

      font-size: 14px;
      line-height: 20px;

      .file-preview-name {
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .file-preview-size {
        color: rgba(92, 101, 110, 1);
      }
    }
  }

  button {
    position: absolute;
    top: 8px;
    right: 6px;
  }

  /* Mobile responsive styles */
  @media (max-width: 768px) {
    .file-preview {
      gap: 6px;
      font-size: 13px;
      line-height: 18px;
      padding-right: 28px;

      > img {
        width: 28px;
        height: 28px;
      }

      svg {
        font-size: 18px;
      }

      .file-preview-meta {
        font-size: 13px;
        line-height: 18px;

        .file-preview-name {
          font-size: 13px;
        }
        .file-preview-size {
          font-size: 12px;
        }
      }
    }

    button {
      top: 6px;
      right: 6px;
    }
  }

  @media (max-width: 480px) {
    .file-preview {
      gap: 6px;
      font-size: 12px;
      line-height: 16px;
      padding-right: 26px;

      > img {
        width: 24px;
        height: 24px;
      }

      svg {
        font-size: 16px;
      }

      .file-preview-meta {
        font-size: 12px;
        line-height: 16px;

        .file-preview-name {
          font-size: 12px;
        }
        .file-preview-size {
          font-size: 11px;
        }
      }
    }

    button {
      top: 4px;
      right: 4px;

      svg {
        width: 16px !important;
        height: 16px !important;
      }
    }
  }
`;
